export class AuthenticationError extends Error {
	skipSentry: boolean;

	statusCode: number;

	constructor(message: string) {
		super(message);
		this.name = 'AuthenticationError';
		this.skipSentry = true;
		this.statusCode = 401;
	}
}
